// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Embedded Attachments (Ballots & Shorts in Community Feed) ─── */

/* ─── Embedded Ballot Card ─── */
.embedded-ballot-card {
  margin: 14px 0 16px 0;
  background: linear-gradient(180deg, rgba(16, 34, 30, 0.7) 0%, rgba(9, 23, 20, 0.85) 100%);
  border: 1px solid rgba(72, 209, 204, 0.22);
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  position: relative;
  overflow: hidden;
}

.embedded-ballot-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #48D1CC 0%, rgba(72, 209, 204, 0.1) 100%);
}

.embedded-ballot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.embedded-ballot-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #48D1CC;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(72, 209, 204, 0.1);
  border: 1px solid rgba(72, 209, 204, 0.25);
  padding: 3px 8px;
  border-radius: 6px;
}

.embedded-option-type-tag {
  font-size: 11px;
  color: #94a3b8;
  background: rgba(255, 255, 255, 0.05);
  padding: 2px 8px;
  border-radius: 6px;
}

.embedded-ballot-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px 0;
  line-height: 1.35;
}

.embedded-ballot-description {
  font-size: 12.5px;
  color: #94a3b8;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.embedded-ballot-error-alert {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #fca5a5;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  animation: fadeInDrawer 0.2s ease-out;
}

/* Ballot Options Rows */
.embedded-ballot-options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.embedded-ballot-option-row {
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: rgba(13, 26, 23, 0.6);
  padding: 10px 14px;
  overflow: hidden;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.embedded-ballot-option-row.interactive-mode {
  cursor: pointer;
}

.embedded-ballot-option-row.interactive-mode:hover {
  background: rgba(72, 209, 204, 0.12);
  border-color: #48D1CC;
  transform: translateX(2px);
}

.embedded-ballot-option-row.user-selected-option {
  border-color: #48D1CC;
  background: rgba(72, 209, 204, 0.15);
}

.embedded-option-progress-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(90deg, rgba(72, 209, 204, 0.22) 0%, rgba(72, 209, 204, 0.35) 100%);
  border-radius: 8px;
  transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1;
}

.embedded-option-content-wrap {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.embedded-option-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.embedded-option-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.embedded-option-text {
  font-size: 13px;
  font-weight: 600;
  color: #f1f5f9;
  word-break: break-word;
}

.embedded-option-stats {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  color: #48D1CC;
  flex-shrink: 0;
}

.embedded-option-votes-count {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.embedded-ballot-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11.5px;
  color: #64748b;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.embedded-ballot-stats {
  display: flex;
  align-items: center;
  gap: 10px;
}

.embedded-voted-badge {
  color: #48D1CC;
  font-weight: 700;
  background: rgba(72, 209, 204, 0.12);
  padding: 2px 7px;
  border-radius: 5px;
}

.embedded-login-hint {
  color: #f59e0b;
  font-weight: 500;
}

/* ─── Embedded Shorts Video Card ─── */
.embedded-short-card {
  margin: 14px 0 16px 0;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(16, 34, 30, 0.7) 0%, rgba(9, 23, 20, 0.85) 100%);
  border: 1px solid rgba(45, 212, 191, 0.22);
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  position: relative;
  overflow: hidden;
}

.embedded-short-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #2dd4bf 0%, rgba(45, 212, 191, 0.1) 100%);
}

.embedded-short-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.embedded-short-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #2dd4bf;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(45, 212, 191, 0.1);
  border: 1px solid rgba(45, 212, 191, 0.25);
  padding: 3px 8px;
  border-radius: 6px;
}

.embedded-linked-ballot-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #48D1CC;
  background: rgba(72, 209, 204, 0.12);
  padding: 2px 7px;
  border-radius: 6px;
}

.embedded-video-player-box {
  position: relative;
  width: 100%;
  height: 380px;
  max-height: 420px;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.embedded-video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.embedded-video-play-btn-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  transition: background 0.2s ease;
}

.embedded-video-player-box:hover .embedded-video-play-btn-wrap {
  background: rgba(0, 0, 0, 0.2);
}

.embedded-video-play-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(45, 212, 191, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  transition: transform 0.2s ease, background 0.2s ease;
}

.embedded-video-player-box:hover .embedded-video-play-btn {
  transform: scale(1.1);
  background: #2dd4bf;
}

.embedded-video-duration-tag {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 3px;
  pointer-events: none;
}

.embedded-video-controls-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
  padding: 14px 10px 6px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.embedded-video-player-box:hover .embedded-video-controls-bar {
  opacity: 1;
}

.embedded-ctrl-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.embedded-ctrl-btn:hover {
  background: rgba(45, 212, 191, 0.6);
}

.embedded-ctrl-spacer {
  flex: 1 1;
}

.embedded-short-info {
  padding-top: 10px;
}

.embedded-short-title {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px 0;
}

.embedded-short-desc {
  font-size: 12px;
  color: #94a3b8;
  margin: 0 0 6px 0;
  line-height: 1.4;
}

.embedded-short-creator-meta {
  font-size: 11px;
  color: #64748b;
}

.embedded-short-creator-meta strong {
  color: #cbd5e1;
}

/* Loading and Fallback */
.embedded-loading,
.embedded-fallback {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  color: #94a3b8;
  padding: 12px 16px;
}

/* Post Header Badges for Attachments */
.post-attached-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 6px;
  margin-left: 6px;
}

.post-ballot-badge {
  background: rgba(72, 209, 204, 0.14);
  color: #48D1CC;
  border: 1px solid rgba(72, 209, 204, 0.25);
}

.post-short-badge {
  background: rgba(45, 212, 191, 0.14);
  color: #2dd4bf;
  border: 1px solid rgba(45, 212, 191, 0.25);
}

/* Feed Filter Tabs */
.feed-filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.feed-filter-btn {
  background: rgba(16, 34, 30, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
}

.feed-filter-btn:hover {
  color: #fff;
  border-color: rgba(72, 209, 204, 0.3);
}

.feed-filter-btn.active {
  background: rgba(72, 209, 204, 0.15);
  border-color: #48D1CC;
  color: #48D1CC;
}

/* ─── Linked Ballot on Embedded Shorts ─── */
.embedded-linked-ballot-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(72, 209, 204, 0.12);
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48D1CC;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.embedded-linked-ballot-pill:hover,
.embedded-linked-ballot-pill.active {
  background: rgba(72, 209, 204, 0.25);
  border-color: #48D1CC;
  color: #fff;
  box-shadow: 0 0 10px rgba(72, 209, 204, 0.25);
}

.ballot-pill-arrow {
  font-size: 8px;
  opacity: 0.8;
}

.embedded-short-linked-ballot-drawer {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid rgba(72, 209, 204, 0.18);
  animation: fadeInDrawer 0.25s ease-out;
}

.linked-ballot-drawer-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 700;
  color: #48D1CC;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 8px;
}

.embedded-short-linked-ballot-drawer .embedded-ballot-card {
  margin: 0;
  border-color: rgba(72, 209, 204, 0.3);
  background: rgba(10, 24, 21, 0.95);
}

@keyframes fadeInDrawer {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Communities/CommunityDetail/EmbeddedAttachments.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,iCAAiC;AACjC;EACE,qBAAqB;EACrB,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;EACnC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,8FAA8F;EAC9F,kBAAkB;EAClB,oDAAoD;EACpD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;EACnC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4EAA4E;EAC5E,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,qBAAqB;EACrB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* ─── Embedded Attachments (Ballots & Shorts in Community Feed) ─── */\n\n/* ─── Embedded Ballot Card ─── */\n.embedded-ballot-card {\n  margin: 14px 0 16px 0;\n  background: linear-gradient(180deg, rgba(16, 34, 30, 0.7) 0%, rgba(9, 23, 20, 0.85) 100%);\n  border: 1px solid rgba(72, 209, 204, 0.22);\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.embedded-ballot-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #48D1CC 0%, rgba(72, 209, 204, 0.1) 100%);\n}\n\n.embedded-ballot-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.embedded-ballot-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #48D1CC;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(72, 209, 204, 0.1);\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  padding: 3px 8px;\n  border-radius: 6px;\n}\n\n.embedded-option-type-tag {\n  font-size: 11px;\n  color: #94a3b8;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 2px 8px;\n  border-radius: 6px;\n}\n\n.embedded-ballot-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 6px 0;\n  line-height: 1.35;\n}\n\n.embedded-ballot-description {\n  font-size: 12.5px;\n  color: #94a3b8;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.embedded-ballot-error-alert {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: #fca5a5;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 8px 12px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  animation: fadeInDrawer 0.2s ease-out;\n}\n\n/* Ballot Options Rows */\n.embedded-ballot-options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.embedded-ballot-option-row {\n  position: relative;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  background: rgba(13, 26, 23, 0.6);\n  padding: 10px 14px;\n  overflow: hidden;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.embedded-ballot-option-row.interactive-mode {\n  cursor: pointer;\n}\n\n.embedded-ballot-option-row.interactive-mode:hover {\n  background: rgba(72, 209, 204, 0.12);\n  border-color: #48D1CC;\n  transform: translateX(2px);\n}\n\n.embedded-ballot-option-row.user-selected-option {\n  border-color: #48D1CC;\n  background: rgba(72, 209, 204, 0.15);\n}\n\n.embedded-option-progress-bar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(90deg, rgba(72, 209, 204, 0.22) 0%, rgba(72, 209, 204, 0.35) 100%);\n  border-radius: 8px;\n  transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 1;\n}\n\n.embedded-option-content-wrap {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.embedded-option-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.embedded-option-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.embedded-option-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: #f1f5f9;\n  word-break: break-word;\n}\n\n.embedded-option-stats {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #48D1CC;\n  flex-shrink: 0;\n}\n\n.embedded-option-votes-count {\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.embedded-ballot-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11.5px;\n  color: #64748b;\n  padding-top: 6px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.embedded-ballot-stats {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.embedded-voted-badge {\n  color: #48D1CC;\n  font-weight: 700;\n  background: rgba(72, 209, 204, 0.12);\n  padding: 2px 7px;\n  border-radius: 5px;\n}\n\n.embedded-login-hint {\n  color: #f59e0b;\n  font-weight: 500;\n}\n\n/* ─── Embedded Shorts Video Card ─── */\n.embedded-short-card {\n  margin: 14px 0 16px 0;\n  width: 100%;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, rgba(16, 34, 30, 0.7) 0%, rgba(9, 23, 20, 0.85) 100%);\n  border: 1px solid rgba(45, 212, 191, 0.22);\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.embedded-short-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #2dd4bf 0%, rgba(45, 212, 191, 0.1) 100%);\n}\n\n.embedded-short-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.embedded-short-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #2dd4bf;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(45, 212, 191, 0.1);\n  border: 1px solid rgba(45, 212, 191, 0.25);\n  padding: 3px 8px;\n  border-radius: 6px;\n}\n\n.embedded-linked-ballot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #48D1CC;\n  background: rgba(72, 209, 204, 0.12);\n  padding: 2px 7px;\n  border-radius: 6px;\n}\n\n.embedded-video-player-box {\n  position: relative;\n  width: 100%;\n  height: 380px;\n  max-height: 420px;\n  background: #000;\n  border-radius: 10px;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.embedded-video-element {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.embedded-video-play-btn-wrap {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.35);\n  transition: background 0.2s ease;\n}\n\n.embedded-video-player-box:hover .embedded-video-play-btn-wrap {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.embedded-video-play-btn {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: rgba(45, 212, 191, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.embedded-video-player-box:hover .embedded-video-play-btn {\n  transform: scale(1.1);\n  background: #2dd4bf;\n}\n\n.embedded-video-duration-tag {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 6px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  pointer-events: none;\n}\n\n.embedded-video-controls-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.8) 100%);\n  padding: 14px 10px 6px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.embedded-video-player-box:hover .embedded-video-controls-bar {\n  opacity: 1;\n}\n\n.embedded-ctrl-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.embedded-ctrl-btn:hover {\n  background: rgba(45, 212, 191, 0.6);\n}\n\n.embedded-ctrl-spacer {\n  flex: 1;\n}\n\n.embedded-short-info {\n  padding-top: 10px;\n}\n\n.embedded-short-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.embedded-short-desc {\n  font-size: 12px;\n  color: #94a3b8;\n  margin: 0 0 6px 0;\n  line-height: 1.4;\n}\n\n.embedded-short-creator-meta {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.embedded-short-creator-meta strong {\n  color: #cbd5e1;\n}\n\n/* Loading and Fallback */\n.embedded-loading,\n.embedded-fallback {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  color: #94a3b8;\n  padding: 12px 16px;\n}\n\n/* Post Header Badges for Attachments */\n.post-attached-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 6px;\n  margin-left: 6px;\n}\n\n.post-ballot-badge {\n  background: rgba(72, 209, 204, 0.14);\n  color: #48D1CC;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n}\n\n.post-short-badge {\n  background: rgba(45, 212, 191, 0.14);\n  color: #2dd4bf;\n  border: 1px solid rgba(45, 212, 191, 0.25);\n}\n\n/* Feed Filter Tabs */\n.feed-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.feed-filter-btn {\n  background: rgba(16, 34, 30, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  transition: all 0.2s ease;\n}\n\n.feed-filter-btn:hover {\n  color: #fff;\n  border-color: rgba(72, 209, 204, 0.3);\n}\n\n.feed-filter-btn.active {\n  background: rgba(72, 209, 204, 0.15);\n  border-color: #48D1CC;\n  color: #48D1CC;\n}\n\n/* ─── Linked Ballot on Embedded Shorts ─── */\n.embedded-linked-ballot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(72, 209, 204, 0.12);\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48D1CC;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.embedded-linked-ballot-pill:hover,\n.embedded-linked-ballot-pill.active {\n  background: rgba(72, 209, 204, 0.25);\n  border-color: #48D1CC;\n  color: #fff;\n  box-shadow: 0 0 10px rgba(72, 209, 204, 0.25);\n}\n\n.ballot-pill-arrow {\n  font-size: 8px;\n  opacity: 0.8;\n}\n\n.embedded-short-linked-ballot-drawer {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(72, 209, 204, 0.18);\n  animation: fadeInDrawer 0.25s ease-out;\n}\n\n.linked-ballot-drawer-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #48D1CC;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 8px;\n}\n\n.embedded-short-linked-ballot-drawer .embedded-ballot-card {\n  margin: 0;\n  border-color: rgba(72, 209, 204, 0.3);\n  background: rgba(10, 24, 21, 0.95);\n}\n\n@keyframes fadeInDrawer {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
